/**
 * Vault counts as unlocked only while setup is complete and session keys are present.
 * Do not sticky-true across a missing vault session (cleared sessionStorage).
 */
export function isVaultSessionUnlocked(
  vaultSetupComplete: boolean,
  hasLiveVaultSession: boolean,
): boolean {
  return vaultSetupComplete && hasLiveVaultSession;
}
